import { render, staticRenderFns } from "./StopLoss.vue?vue&type=template&id=0ac060a4&scoped=true&"
import script from "./StopLoss.vue?vue&type=script&lang=js&"
export * from "./StopLoss.vue?vue&type=script&lang=js&"
import style0 from "./StopLoss.vue?vue&type=style&index=0&id=0ac060a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac060a4",
  null
  
)

export default component.exports